import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Storytelling } from '../components/Storytelling';
import { Services } from '../components/Services';
import { NailsGallery } from '../components/NailsGallery';
import { BrowsGallery } from '../components/BrowsGallery';
import { HairGallery } from '../components/HairGallery';
import { Testimonials } from '../components/Testimonials';
import { InstagramReel } from '../components/InstagramReel';
import { BookingBanner } from '../components/BookingBanner';
import { BookingIframe } from '../components/BookingIframe';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="w-full min-h-screen" data-id="element-194">
      <Navbar data-id="element-195" />
      <Hero data-id="element-196" />
      <Storytelling data-id="element-197" />
      <Services data-id="element-198" />
      <NailsGallery data-id="element-199" />
      <BrowsGallery data-id="element-200" />
      <HairGallery data-id="element-201" />
      <Testimonials data-id="element-202" />
      <InstagramReel data-id="element-203" />
      <BookingBanner data-id="element-204" />
      <BookingIframe data-id="element-205" />
      <Footer data-id="element-206" />
    </main>;
}